import {createSlice, createAsyncThunk, PayloadAction} from '@reduxjs/toolkit';
import type {RootState} from './store';
import {getStoreInformation} from '../api/store.api';
interface StoreInformationResponse {
  resultCode: string;
  message: string;
  result: boolean;
  entity: string;
  store_code: string;
  store_name: string;
  pincode: string;
  latitude: string;
  longitude: string;
  server_ip: string;
  store_open_timings: string;
  store_close_timing: string;
}

const storeInformationData = {
  resultCode: '',
  message: '',
  result: false,
  entity: '',
  store_code: '',
  store_name: '',
  pincode: '',
  latitude: '',
  longitude: '',
  server_ip: '',
  store_open_timings: '',
  store_close_timing: '',
};
interface FetchStoreInformationPayload {
  store_input_code?: string | null;
  store_code?: string | null;
  mobile_number?: string | null;
}

interface StoreInformation {
  storeInformation: StoreInformationResponse;
  error: string;
}
// Define the initial state using that type
const initialState: StoreInformation = {
  storeInformation: storeInformationData,
  error: '',
};
export const fetchStoreInformation = createAsyncThunk(
  'store/storeInformation',
  async (payload: FetchStoreInformationPayload, thunkApi) => {
    return getStoreInformation(payload)
      .then(response => {
        return response;
      })
      .catch(error => {
        return thunkApi.rejectWithValue(error.response.data);
      });
  },
);
export const storeInformationSlice = createSlice({
  name: 'storeInfo',
  // `createSlice` will infer the state type from the `initialState` argument
  initialState,
  reducers: {
    resetStoreInformation: () => initialState,
  },
  extraReducers: builder => {
    builder.addCase(fetchStoreInformation.pending, state => {
      return state;
    });
    builder.addCase(fetchStoreInformation.fulfilled, (state, {payload}) => {
      state.storeInformation = payload;
    });
    builder.addCase(fetchStoreInformation.rejected, (state, action) => {
      state.error = action.toString();
    });
  },
});

// Other code such as selectors can use the imported `RootState` type
export const {resetStoreInformation} = storeInformationSlice.actions;
export const error = (state: RootState): string =>
  state.storeInformationReducer.error;
export const storeInformation = (state: RootState): StoreInformationResponse =>
  state.storeInformationReducer.storeInformation;

export default storeInformationSlice.reducer;
